"use client";

import { useState, useEffect } from "react";
import ProductCategoryFilters from "./ProductCategoryFilters";
import ProductGrid from "./ProductGrid";

export default function ProductsInteractive() {
  const [isHydrated, setIsHydrated] = useState(false);
  const [activeFilter, setActiveFilter] = useState("all");

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  const handleFilterChange = (categoryId: string) => {
    if (!isHydrated) return;
    setActiveFilter(categoryId);
  };

  return (
    <div className="container mx-auto px-4 max-w-7xl">
      <ProductCategoryFilters
        onFilterChange={handleFilterChange}
        activeFilter={activeFilter}
      />
      <ProductGrid activeFilter={activeFilter} />
    </div>
  );
}